import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const localAuth = localStorage.getItem("isAuthenticated");

  // ✅ Allow auth callback route ALWAYS
  if (location.pathname === "/auth/callback") {
    return children;
  }

  if (!localAuth) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;